import Cookies from 'js-cookie';
import { DEFAULT_LANGUAGE, SITE_NAME } from '../config/constants';

export function getLanguageByPath(path, fallback = DEFAULT_LANGUAGE) {
  return /^\/[a-z]{2}(\/.*)?$/g.test(path)
    ? path.replace(/^\/([a-z]{2})(\/.*)?/, '$1')
    : fallback;
}

export function getDocumentTitle(title) {
  if (!title) {
    return SITE_NAME;
  }

  return `${title} | ${SITE_NAME}`;
}

export function bytesToSize(bytes) {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) return 'n/a';
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
  if (i === 0) return `${bytes} ${sizes[i]}`;
  return `${(bytes / (1024 ** i)).toFixed(1)} ${sizes[i]}`;
}

// Set a cookie so we know the user has seen this Takeover homepage.
export function setTakeoverCookieAndReload(takeoverId) {
  Cookies.set('takeover', takeoverId, { expires: 30 });
  window.location.reload();
}

export const MUNICIPALITY_AND_PROFESSIONALS_TERM_ID = 6538;
export const COLUMN_TERM_ID = 122;
export const vacancyURLIdentifier = '/vacatures/';
export const rtlLanguages = ['ar', 'pr', 'fa'];
